import { useMemo } from 'react';

import cobrandingPartnerships from '../constants/cobranding_partnerships';

export default function useCobrandingPartnership() {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return { hasCobrandingPartnership: false };
    }

    const { location = {} } = window;
    const { search = {} } = location;
    const urlParams = new URLSearchParams(search);
    const affiliate = urlParams.get('ref') || localStorage.getItem('utm_campaign');
    const isValidPartnership = Object.keys(cobrandingPartnerships).includes(
      affiliate
    );
    const partnership = isValidPartnership ? cobrandingPartnerships[affiliate] : {};

    return {
      ...partnership,
      hasPartnership: isValidPartnership,
    };
  }, []);
}
